import Vue from 'vue'
import './add-to-bag-button.vue'

export default el => new Vue({
  name: 'Add To Bag Button',
  el,
})